<template>
  <div ref="msgList" class="msgList bubbleList">
    <p v-if="message.length === 0" class="topload">
      No more
    </p>
    <p
      v-for="(item, index) in message"
      :key="index"
      :class="userClass(item, userName)"
    >

      <span class="ts">{{ item.dateTime | dateFormat }}</span>
      <span v-if="item.type === 'talk'" class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        {{ item.message }}
      </span>
      <span v-else-if="item.type === 'image'" class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        <img
          :src="baseUrl + item.message.split('|')[0]"
          :alt="item.message.split('|')[1]"
          @click="viewImage"
        />
      </span>
      <span v-else-if="item.type === 'file'" class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        <a :href="baseUrl + item.message.split('|')[0]" target="_blank">
          {{ item.message.split("|")[1] }}
        </a>
      </span>
      <span v-else-if="item.type === 'audio'" class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        <audio controls="controls">
          <source
            :src="baseUrl + item.message.split('|')[0]"
            type="audio/aac"
          />
        </audio>
      </span>
      <span v-else-if="item.type === 'video'" class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        <video controls>
          <source
            :src="baseUrl + item.message.split('|')[0]"
            type="video/mp4"
          />
        </video>
      </span>
      <span v-else class="tm"><div v-if="item.sendFail" class="jljw_im_visitor_loading"></div>
        {{ item.message }}
      </span>
      <i
        v-if="
          (item.user !== undefined &&
            item.user.name === userName &&
            item.read !== undefined) || item.sendFail
        "
        class="over"
      >
        {{item.sendFail?"sending...":item.read ? "read" :"unread" }}
      </i>
    </p>
  </div>
</template>

<script>
export default {
  name: "MessageContent",
  props: {
    message: {
      type: Array,
      default: () => []
    },
    userName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      baseUrl: this.$baseURL
    };
  },
  watch: {
    message() {
      let that = this;
      setTimeout(() => {
        let box = that.$refs.msgList;
        box.scrollTop = box.scrollHeight;
      }, 200);
    }
  },
  methods: {
    viewImage(e) {
      // console.log(e);
      let src = e.target.src;
      this.$emit("preview", src);
    },
    userClass(msg, userName) {
      var className = "sys";
      if (msg.user === undefined) {
        className = "sys";
      } else if (msg.user.name === userName){
        className = "self";
      } else {
        className = "other";
      }
      if (msg.sendFail) {
        className = "self";
      }
      return className;
    }
  }
};
</script>

<style scoped>
  .tm {
    position: relative;
  }
</style>